/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ZobrazeniE {
    CelkovyPocetVSystemu = 'CELKOVY_POCET_V_SYSTEMU',
    ZmenaVCase = 'ZMENA_V_CASE'
}

